<script setup lang="ts">
import { ref, onMounted } from "vue";
import { WorkflowStatus } from "~/api";
import { Edit } from "@element-plus/icons-vue";
import { VueDraggableNext } from "vue-draggable-next";

const props = defineProps<{
  statusList: WorkflowStatus[];
}>();

const emit = defineEmits<{
  (e: "editingStatus", value: WorkflowStatus): void;
}>();

const localStatusList = ref<WorkflowStatus[]>([]);

onMounted(() => {
  localStatusList.value = props.statusList;
});
</script>

<template>
  <div v-if="localStatusList" class="sorting-status">
    <VueDraggableNext class="dragArea" :list="localStatusList">
      <div
        v-for="(status, index) in localStatusList"
        :key="status.code || status.label || index"
        class="drag-item"
      >
        <i :class="`mdi mdi-drag-vertical`"></i>
      </div>
    </VueDraggableNext>
    <el-table :data="localStatusList" style="width: 100%">
      <el-table-column label=" Display Label" prop="label">
        <template #default="{ row }">
          <span>{{ row.label }} </span>
        </template>
      </el-table-column>
      <el-table-column label="Code" prop="code">
        <template #default="{ row }">
          <span>{{ row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Mark as Endpoint" prop="isEndpoint">
        <template #default="{ row }">
          <el-checkbox
            v-model="row.isEndpoint"
            class="endpoint-checkbox"
          ></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column label="Edit">
        <template #default="{ row }">
          <div class="actions-column">
            <el-button
              :icon="Edit"
              size="small"
              circle
              @click="emit('editingStatus', row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped lang="less">
.sorting-status {
  display: flex;
  .dragArea {
    margin-top: 1.8em;
    cursor: grab;
    .drag-item {
      margin-top: 1.5em;
    }
  }

  .endpoint-checkbox {
    display: block;
    margin-left: 50px;
  }

  .actions {
    margin-left: 8px;
    .arrow-button {
      margin: 0 2px;
      padding: 2px 6px;
      font-size: 12px;
    }
  }
}
</style>
